module.exports = __webpack_public_path__ + "img/add_btn_icon490.f2891afb.svg";